import ContentContainer from "@/src/components/containers/ContentContainer";
import GenericHead from "@/src/components/Head/GenericHead";

const AboutPage = () => {
  return (
    <>
      <GenericHead title={"About Supercoach playbook"} />
      <div className="bg-white">
        <ContentContainer bgColor="white">
          <div className={"flex flex-col gap-4 py-4 bg-white 123"}>
            <h1>About Us</h1>
            <p>
              SC Playbook aims to provide expert NRL and cricket insights,
              focusing on Supercoach with analysis across Classic, head-to-head
              and Draft formats.
            </p>
            <p>
              Daily content created from the knowledge of SuperCoach experts,
              past overall champions and NRL stars will help passionate players
              to gain an edge over rivals.
            </p>
            <p>
              Daily pre-season articles and podcasts will help savvy coaches
              establish their Round 1 teams, while articles will be delivered by
              our experts throughout the season.
            </p>
            <p>
              Our podcast network produces over six shows per week to our
              audience during the NRL season, and numerous during the Australian
              cricket summer.
            </p>
            <p>
              The podcast peaked at number two on the Spotify Australia sports
              podcast charts in March 2024.
            </p>
            <p>Looking for an extra leg up?</p>
            <p>
              Our subscription package provides access to stacks of extra
              content throughout the year, including a host of additional
              premium articles every week, access to our subscriber only Discord
              channel where we deliver weekly question and answers, late mail
              news, provide insights into how we think about the game while also
              allowing the community to discuss the great game together.
            </p>
            <p>
              Back-to-back in 2021 and 2022, our in-house contributors NRL SC
              Playbook league finished first overall out of over 20,000 leagues.
            </p>
            <p>
              Get on board with the SC Playbook crew to take your game to the
              next level
            </p>
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export default AboutPage;
